var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 11.0833C7.39312 11.0833 6.65125 10.776 6.10427 10.2291C5.55729 9.68208 5.25 8.94022 5.25 8.16667C5.25 7.39312 5.55729 6.65125 6.10427 6.10427C6.65125 5.55729 7.39312 5.25 8.16667 5.25C8.94022 5.25 9.68208 5.55729 10.2291 6.10427C10.776 6.65125 11.0833 7.39312 11.0833 8.16667C11.0833 8.54969 11.0079 8.92896 10.8613 9.28283C10.7147 9.63669 10.4999 9.95822 10.2291 10.2291C9.95822 10.4999 9.63669 10.7147 9.28283 10.8613C8.92896 11.0079 8.54969 11.0833 8.16667 11.0833ZM8.16667 0C6.00073 0 3.92351 0.860414 2.39196 2.39196C0.860414 3.92351 0 6.00073 0 8.16667C0 14.2917 8.16667 23.3333 8.16667 23.3333C8.16667 23.3333 16.3333 14.2917 16.3333 8.16667C16.3333 6.00073 15.4729 3.92351 13.9414 2.39196C12.4098 0.860414 10.3326 0 8.16667 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.211b00acb4de35066152fc1b37dbcd04.svg";
export { ForwardRef as ReactComponent };